import './style.scss';


export function footerBlock() {
  const footerSelector = document.querySelector('footer');
  if (!footerSelector) return;

  if (window.innerWidth <= 768) {
    footerSelector.querySelectorAll('img').forEach(img => {
      const parent = img.parentElement;
      if (!parent) return;
      if (img.naturalWidth < 80) {
        parent.classList.add('is-small');
      }
    });
  }

    const toggles = footerSelector.querySelectorAll('.links-wrapper.toggle-mobile');

    if (!toggles.length) return;

    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    toggles.forEach(wrapper => {
      const head = wrapper.querySelector('.toggle-head');

      if (!head) return;

      head.addEventListener('click', () => {
        if (!isMobile()) return;
        wrapper.classList.toggle('is-open');
      });
    });

    // Reset state when resizing to desktop
    window.addEventListener('resize', () => {
      if (!isMobile()) {
        toggles.forEach(wrapper => wrapper.classList.remove('is-open'));
      }
    });



}

